import React, { createContext, useContext, useState } from "react";

const SESSION_KEY = "siteSelection";

function readFromSession() {
    try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

const SiteSelectionContext = createContext();

export default function SiteSelectionProvider({ children }) {
    const stored = readFromSession();
    const [compCode, setCompCode] = useState(stored?.compCode || "");
    const [compName, setCompName] = useState(stored?.compName || "");
    const [siteCode, setSiteCode] = useState(stored?.siteCode || null);
    const [siteName, setSiteName] = useState(stored?.siteName || null);

    // 회사 + 사업장 전체 설정
    const setSiteSelection = (cc, cn, sc, sn) => {
        setCompCode(cc || "");
        setCompName(cn || "");
        setSiteCode(sc || null);
        setSiteName(sn || null);
        sessionStorage.setItem(SESSION_KEY, JSON.stringify({
            compCode: cc || "",
            compName: cn || "",
            siteCode: sc || null,
            siteName: sn || null,
        }));
    };

    // 전체 초기화 (회사 + 사업장)
    const clearSiteSelection = () => {
        setCompCode("");
        setCompName("");
        setSiteCode(null);
        setSiteName(null);
        sessionStorage.removeItem(SESSION_KEY);
    };

    // 사업장만 초기화 (회사는 유지)
    const clearSite = () => {
        setSiteCode(null);
        setSiteName(null);
        if (compCode) {
            sessionStorage.setItem(SESSION_KEY, JSON.stringify({
                compCode,
                compName,
                siteCode: null,
                siteName: null,
            }));
        }
    };

    return (
        <SiteSelectionContext.Provider value={{
            compCode, compName, siteCode, siteName,
            setSiteSelection, clearSiteSelection, clearSite,
        }}>
            {children}
        </SiteSelectionContext.Provider>
    );
}

export function useSiteSelection() {
    return useContext(SiteSelectionContext);
}
